// Smart Magenta -- buscador guiado. Porta de visual/gen_v8.py: a logica ja
// lia data-attributes do DOM (nao um JSON externo), entao a adaptacao para
// cartoes renderizados pelo Liquid foi direta. ASCII puro por seguranca de
// encoding (ver CLAUDE.md do repo do projeto).
//
// 06/09: passou a mostrar UMA pergunta por vez, com barra de progresso e
// navegacao. As quatro empilhadas de uma vez pareciam formulario. A escolha
// fica visivel ate a pessoa tocar em Continuar: isso evita que a tela salte
// enquanto ela ainda esta lendo ou tentando corrigir um toque.
(function () {
  var bsc = document.getElementById('sm-bsc');
  if (!bsc) return;

  var CAMPOS = ['cenario', 'porta', 'abertura', 'preco'];
  var ROTULOS = ['Pra que vai usar', 'Sua porta', 'Como abrir', 'Investimento'];
  var sel = { cenario: null, porta: null, abertura: null, preco: null };
  var hits = [].slice.call(document.querySelectorAll('#sm-res .sm-hit'));
  // Mantem as correspondencias compraveis na frente sem esconder as demais.
  hits.sort(function (a, b) {
    return Number(b.getAttribute('data-disponivel') === 'true') -
      Number(a.getAttribute('data-disponivel') === 'true');
  });
  var grade = document.getElementById('sm-res');
  for (var h = 0; h < hits.length; h++) { grade.appendChild(hits[h]); }
  var etapas = {};
  for (var i = 0; i < CAMPOS.length; i++) {
    etapas[CAMPOS[i]] = document.querySelector('[data-etapa="' + CAMPOS[i] + '"]');
  }
  var caixa = document.getElementById('sm-bsc-r');
  var txt = document.getElementById('sm-r-txt');
  var vazio = document.getElementById('sm-vazio');
  var prog = document.getElementById('sm-bsc-prog');
  var progTxt = document.getElementById('sm-prog-txt');
  var btVoltar = document.getElementById('sm-voltar');
  var btSeguir = document.getElementById('sm-seguir');
  var btPular = document.getElementById('sm-pular');
  var atual = 0;

  function tem(el, campo, v) {
    return el.getAttribute('data-' + campo).split(' ').indexOf(v) >= 0;
  }
  function casa(el, s) {
    for (var i = 0; i < CAMPOS.length; i++) {
      var c = CAMPOS[i];
      if (s[c] && !tem(el, c, s[c])) return false;
    }
    return true;
  }
  function conta(s) {
    var n = 0;
    for (var i = 0; i < hits.length; i++) { if (casa(hits[i], s)) n++; }
    return n;
  }
  function desabilita(campo) {
    var bts = document.querySelectorAll('[data-passo="' + campo + '"]');
    for (var i = 0; i < bts.length; i++) {
      var teste = { cenario: sel.cenario, porta: sel.porta, abertura: sel.abertura, preco: sel.preco };
      teste[campo] = bts[i].getAttribute('data-v');
      var n = conta(teste);
      bts[i].disabled = n === 0;
      var q = bts[i].querySelector('.sm-qt-p');
      if (q) { q.textContent = n === 1 ? '1 modelo' : n + ' modelos'; }
      if (n === 0 && bts[i].getAttribute('aria-pressed') === 'true') {
        bts[i].setAttribute('aria-pressed', 'false'); sel[campo] = null;
      }
    }
  }

  // Mostra so a etapa da vez e atualiza barra + botoes.
  function mostraEtapa() {
    for (var i = 0; i < CAMPOS.length; i++) {
      etapas[CAMPOS[i]].classList.toggle('sm-oculto', i !== atual);
    }
    var bolas = prog ? prog.querySelectorAll('.sm-prog-b') : [];
    for (var j = 0; j < bolas.length; j++) {
      bolas[j].className = 'sm-prog-b' + (j < atual ? ' sm-feito' : (j === atual ? ' sm-agora' : ''));
    }
    if (progTxt) {
      progTxt.textContent = 'Etapa ' + (atual + 1) + ' de 4 - ' + ROTULOS[atual] +
        (atual === 0 ? ' - leva menos de 1 minuto' : '');
    }
    btVoltar.hidden = atual === 0;
    btSeguir.textContent = atual === CAMPOS.length - 1 ? 'Ver os modelos' : 'Continuar ->';
    // Sem escolha na etapa atual, "Continuar" nao ajuda: o caminho e "Nao sei".
    btSeguir.disabled = !sel[CAMPOS[atual]];
    btPular.hidden = atual === CAMPOS.length - 1 && !!sel[CAMPOS[atual]];
  }

  function pinta() {
    var n = 0;
    for (var i = 0; i < hits.length; i++) {
      var ok = casa(hits[i], sel);
      hits[i].style.display = ok ? '' : 'none';
      if (ok) n++;
    }
    caixa.classList.remove('sm-oculto');
    vazio.classList.toggle('sm-oculto', n > 0);
    // "servem pra voce" prometia compatibilidade que o filtro nao apura:
    // escolher so o cenario (ex.: Airbnb) nao diz nada sobre a porta. O
    // texto agora e factual, e pede o proximo refino enquanto ele faltar.
    var base = n === 1 ? '1 modelo encontrado' : n + ' modelos encontrados';
    if (!sel.porta) {
      base += ' -- escolha o tipo de porta pra refinar';
    }
    txt.textContent = base;
    desabilita('porta'); desabilita('abertura'); desabilita('preco');
    mostraEtapa();
  }

  function vaiPara(i) {
    atual = Math.max(0, Math.min(CAMPOS.length - 1, i));
    mostraEtapa();
    if (prog) { prog.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
  }

  bsc.addEventListener('click', function (ev) {
    var b = ev.target.closest('[data-passo]');
    if (!b || b.disabled) return;
    var campo = b.getAttribute('data-passo'), v = b.getAttribute('data-v');
    var irmaos = document.querySelectorAll('[data-passo="' + campo + '"]');
    if (sel[campo] === v) { sel[campo] = null; } else { sel[campo] = v; }
    for (var i = 0; i < irmaos.length; i++) {
      irmaos[i].setAttribute('aria-pressed', String(irmaos[i] === b && sel[campo] === v));
    }
    pinta();
  });

  btSeguir.addEventListener('click', function () {
    if (atual < CAMPOS.length - 1) { vaiPara(atual + 1); }
    else { caixa.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  });
  btVoltar.addEventListener('click', function () { vaiPara(atual - 1); });
  btPular.addEventListener('click', function () {
    // "Nao sei" nao e pular no vazio: limpa a escolha da etapa (o filtro
    // deixa de existir) e segue, em vez de travar quem nao sabe medir a
    // porta ou nao definiu orcamento.
    var campo = CAMPOS[atual];
    sel[campo] = null;
    var bts = document.querySelectorAll('[data-passo="' + campo + '"]');
    for (var i = 0; i < bts.length; i++) { bts[i].setAttribute('aria-pressed', 'false'); }
    pinta();
    if (atual < CAMPOS.length - 1) { vaiPara(atual + 1); }
    else { caixa.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  });

  var recomeca = document.getElementById('sm-recomeca');
  if (recomeca) {
    recomeca.addEventListener('click', function () {
      sel = { cenario: null, porta: null, abertura: null, preco: null };
      var bts = document.querySelectorAll('[data-passo]');
      for (var i = 0; i < bts.length; i++) {
        bts[i].setAttribute('aria-pressed', 'false'); bts[i].disabled = false;
        var q = bts[i].querySelector('.sm-qt-p'); if (q) { q.textContent = ''; }
      }
      caixa.classList.add('sm-oculto');
      atual = 0;
      mostraEtapa();
      document.getElementById('sm-buscador-secao').scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  mostraEtapa();
})();
